import { Injectable } from '@angular/core';
import { RpSdk, RpSdkParams } from '@idport/oidc-rp-sdk';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { from } from 'rxjs/observable/from';
import * as auth from '../../core/actions/logout.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { LoggerService } from '../../core/services/logger.service';
import { selectConfig } from '../config/config.selector';
import { ConfigModel } from '../config/config.model';

const WINDOW_PARAM_NAME = 'DT_OIDC_PARAMS'; // see rp_iframe.html


@Injectable()
export class AuthenticationOidcService {

    private rpSdk: RpSdk;
    private config: ConfigModel;

    private get baseUrl(): string {
        return document.getElementsByTagName('base')[0].href;
    }

    constructor(
        private store: Store<AppState>,
        private logger: LoggerService
    ) {
        this.store.select(selectConfig).subscribe(config => {
            this.config = config;
        });
    }

    login(i: {
        idToken?: string,
        code?: string,
        state?: string,
        lang?: string
    }): Observable<string> {
        console.log(i);

        this.initRpSdk();

        if (!i.code) {
            console.log('Generation auth request');
            if (i.lang) {
                this.rpSdk.generateAuthenticationRequest(i.state, {'lang': i.lang});
            } else {
                this.rpSdk.generateAuthenticationRequest(i.state);
            }
            return of();
        } else {
            return this.obtainAccessToken(i.idToken, i.code);
        }
    }

    logout() {
        this.rpSdk.generateLogoutRequest();
    }

    private initRpSdk() {
        if (this.rpSdk) {
            throw Error('OIDC_ALREADY_INITIATED');
        }

        const rpSdkParams: RpSdkParams = {
            OP_BASE_FQDN: this.config.mepOpBaseFqdn,
            OP_JWKS_KEYS: {keys: []},
            RP_CLIENT_ID: this.config.webApiClientId,
            RP_SCOPES: 'openid',
            RP_REDIRECT_URI: this.baseUrl,
            RP_IFRAME_ABSOLUTE_PATH: this.baseUrl + 'rp-iframe.html',
            OP_IFRAME_RELATIVE_PATH: '/oidc-sm/op-iframe/',
            RP_LOGOUT_URI: this.config.mciLogoutRedirectURI,
            RP_CALLBACK: (evt: RpSdkCallbackEvt) => {
                this.rpCallbackHandler(evt);
            },
        };

        this.rpSdk = new RpSdk(rpSdkParams);

        window[WINDOW_PARAM_NAME] = {
            OP_IFRAME_ID: 'op',
            OP_BASE_FQDN: rpSdkParams.OP_BASE_FQDN,
            OP_CALL_INTERVAL: 10
        };
    }

    private obtainAccessToken(idToken, code): Observable<string> {
        return from(this.rpSdk.generateAccessToken(code, idToken));
    }

    private rpCallbackHandler(evt: RpSdkCallbackEvt) {

        if (evt.event_name === EventNamesEnum.EvtOpStateChanged) {
            this.store.dispatch(new auth.RedirectAction(this.config.mciLogoutRedirectURI));
        }

        if (evt.event_name === EventNamesEnum.EvtAuthorizationError) {
            this.logger.error('[AuthenticationOidcService] ' + evt.event_name + ' ' + JSON.stringify(evt.event_data));
        }
    }

}


enum EventNamesEnum {
    EvtAccessTokenObtained = 'EvtAccessTokenObtained',
    EvtAuthorizationError = 'EvtAuthorizationError',
    EvtRpIframeLoaded = 'EvtRpIframeLoaded',
    EvtOpStateChanged = 'EvtOpStateChanged'
}

interface RpSdkCallbackEvt {
    event_name: EventNamesEnum;
    event_data?: any;
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/url-params/authentication-oidc.service.ts